export default __webpack_public_path__ + "static/media/Mahabalipuram_Arjuna's penance.433bea22.JPG";